import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

class Variants extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {pay_terms: 'pre_pay', pay_amount: this.props.selectedProductsTotalAmount, due_amount: 0};

  //   this.handleChange = this.handleChange.bind(this);
  // }

  // handleChange(event) {
  //   if(event.target.name === 'pay_amount') this.setState({pay_amount: event.target.value, due_amount: this.props.selectedProductsTotalAmount - event.target.value})
  //   else this.setState({pay_terms: event.target.value})
  // }

  // componentDidUpdate(prevProps) {
  //   if (this.props.selectedProductsTotalAmount !== prevProps.selectedProductsTotalAmount) {
  //     this.setState({pay_amount: this.props.selectedProductsTotalAmount, due_amount: 0})
  //   }
  // }

  render() {
    const {
      selectedProducts,
      isSubmitting,
      type,
      handleVariantQuantityChange,
      handleVariantRemove,
      handlePurchaseOrder,
      handleMasterPOIID
      // selectedProductsTotalAmount
    } = this.props;

    const variants = selectedProducts.map((product, index) => {
      return (
        <>
          <div className="card-block">
            <div className="block-body">
              <>
                <Form.Control
                  name="master_po_id"
                  size={"sm"}
                  className="mr-3 mb-3"
                  placeholder="Master POI ID"
                  onChange={handleMasterPOIID}
                  type={"text"}
                />
                <div
                  className="variation-card"
                  style={{ borderBottom: "none" }}
                >
                  <div className="variation-header v-middle">
                    <div className="d-flex v-middle">
                      <h4 className="variation-title mb-0 nowrap">
                        <span>
                          {product.product_title
                            ? product.product_title
                            : "N/A"}
                        </span>
                        <span> - </span>
                        <span>
                          {type === "purchaseOrder" &&
                          product.product_attribute_values.length > 0
                            ? product.product_attribute_values.map(
                                (val, index) => {
                                  let dash =
                                    index <
                                    product.product_attribute_values.length - 1
                                      ? "-"
                                      : "";
                                  return val.value + dash;
                                }
                              )
                            : ""}
                          (<small>{product.sku}</small>)
                        </span>
                      </h4>
                    </div>
                  </div>

                  <table className="table">
                    {type === "purchaseOrder" ? (
                      <thead>
                        <tr>
                          <th>Supplier</th>
                          <th>Price (BDT)</th>
                          <th>Quantity</th>
                          <th>Total price</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                    ) : (
                      <thead>
                        <tr>
                          <th>Price (BDT)</th>
                          <th>Quantity</th>
                          <th>Total price</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                    )}

                    <tbody>
                      {type === "purchaseOrder" &&
                        product.suppliers_variants.map((val, i) => {
                          return (
                            <tr>
                              <td style={{ width: "25%" }}>
                                <strong className="nowrap">
                                  {val.supplier_name
                                    ? val.supplier_name
                                    : "N/A"}
                                </strong>
                              </td>
                              <td style={{ width: "20%" }}>
                                <Form.Control
                                  name="special_price"
                                  size={"sm"}
                                  step="0.01"
                                  className="mr-3"
                                  value={val.supplier_price}
                                  disabled={true}
                                  readOnly
                                  type={"text"}
                                />
                              </td>
                              <td style={{ width: "20%" }}>
                                <input
                                  name={val.supplier_name}
                                  className="form-control form-control-sm"
                                  required
                                  min="1"
                                  type="number"
                                  value={
                                    val.quantity !== undefined
                                      ? val.quantity
                                      : ""
                                  }
                                  onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      e.stopPropagation();
                                    }
                                  }}
                                  onChange={(e) =>
                                    handleVariantQuantityChange(
                                      e,
                                      val,
                                      val.variant_id
                                    )
                                  }
                                />
                              </td>
                              <td style={{ width: "20%" }}>
                                {val.totalPrice !== undefined
                                  ? val.totalPrice
                                  : "_"}
                              </td>
                              <td style={{ width: "15%" }}>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={(e) =>
                                    handleVariantRemove(
                                      e,
                                      val.id,
                                      product.id
                                    )
                                  }
                                >
                                  X
                                </Button>
                              </td>
                            </tr>
                          );
                        })}

                      {type === "dhPurchaseOrder" && (
                        <tr>
                          <td style={{ width: "25%" }}>
                            <Form.Control
                              name="special_price"
                              size={"sm"}
                              step="0.01"
                              className="mr-3"
                              value={product.price_distribution}
                              readOnly
                              autoComplete="off"
                              type={"text"}
                            />
                          </td>
                          <td style={{ width: "25%" }}>
                            <input
                              name="quantity"
                              className="form-control form-control-sm"
                              autoComplete="off"
                              required
                              min="1"
                              type="number"
                              value={
                                product.quantity !== undefined
                                  ? product.quantity
                                  : ""
                              }
                              onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }
                              }}
                              onChange={(e) =>
                                handleVariantQuantityChange(
                                  e,
                                  product,
                                  product.id,
                                  product.product_id
                                )
                              }
                            />
                          </td>
                          <td style={{ width: "25%" }}>
                            {product.totalPrice !== undefined 
                              ? product.totalPrice
                              : "_"}
                          </td>
                          <td style={{ width: "25%" }}>
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={(e) =>
                                handleVariantRemove(
                                  e,
                                  product.id,
                                )
                              }
                            >
                              X
                            </Button>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            </div>
          </div>
        </>
      );
    });

    return (
      <div>
        {selectedProducts.length > 0 && (
          <Form onSubmit={(e) => handlePurchaseOrder(e, this.state)}>
            {variants}
            {/* <div className="card-block">
              <div className="block-body d-flex" style={{flexDirection: "row-reverse"}}>
                <div>
                  <label>Total amount</label>
                  <div>{selectedProductsTotalAmount}</div>
                </div>
                &emsp;
                <div className={this.state.pay_terms === 'post_good' ? 'd-none' : ''}>
                  <label>Due amount</label>
                  <input type="number" name="pay_amount" className="form-control" disabled onChange={this.handleChange} min={selectedProductsTotalAmount - this.state.pay_amount} max={selectedProductsTotalAmount} value={this.state.due_amount} />
                </div>
                &emsp;
                <div className={this.state.pay_terms === 'post_good' ? 'd-none' : ''}>
                  <label>Amount to pay</label>
                  <input type="number" name="pay_amount" className="form-control" onChange={this.handleChange} min={0} max={selectedProductsTotalAmount} value={this.state.pay_amount} />
                </div>
                &emsp;
                <div>
                  <label>Payment Terms</label>
                  <select className="form-control" name="pay_terms" onChange={this.handleChange}>
                    <option value="pre_pay">Pre-payment</option>
                    <option value="post_good">Post Good Receive</option>
                  </select>
                </div>
              </div>
            </div> */}
            <div className="card-block">
              <div className="block-body d-flex">
                <div className="ml-auto">
                  <Link
                    className="btn btn-lg btn-default mr-2"
                    to={`/${type}/list`}
                  >
                    Cancel
                  </Link>

                  <Button
                    size="lg"
                    type={`submit`}
                    disabled={isSubmitting}
                    variant="primary"
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </div>
    );
  }
}

export default Variants;
